module.exports = __webpack_public_path__ + "static/media/modalButton--close.56ada31d.svg";